import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Settings } from 'lucide-react';

function SettingPage() {
  const [form, setForm] = useState({
    free_max_attempts: 0,
    chat_max_text: '',
    chat_max_create_session: '',
    api_ai_max_token: '',
    nama_aplikasi: '',
    logo_image: null,
    max_assistant: 0,
    background_image: null,
  });

  const [preview, setPreview] = useState({
    logo: '',
    background: '',
  });

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/setting`, {
        withCredentials: true,
      });

      const settings = res.data.settings;

      if (settings) {
        setForm({
          free_max_attempts: settings.free_max_attempts || 0,
          max_assistant: settings.free_examination_assist || 0,
          chat_max_text: settings.chat_max_text || '',
          chat_max_create_session: settings.chat_max_create_session || '',
          api_ai_max_token: settings.api_ai_max_token || '',
          nama_aplikasi: settings.nama_aplikasi || '',
          logo_image: null,
          background_image: null,
        });

        setPreview({
          logo: settings.logo_image ? `${process.env.REACT_APP_API_BASE_URL}/${settings.logo_image}` : '',
          background: settings.background_image ? `${process.env.REACT_APP_API_BASE_URL}/${settings.background_image}` : '',
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Gagal memuat pengaturan.', 'error');
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'logo_image' && files.length > 0) {
      setForm((prev) => ({ ...prev, logo_image: files[0] }));
      setPreview((prev) => ({ ...prev, logo: URL.createObjectURL(files[0]) }));
    } else if (name === 'background_image' && files.length > 0) {
      setForm((prev) => ({ ...prev, background_image: files[0] }));
      setPreview((prev) => ({ ...prev, background: URL.createObjectURL(files[0]) }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.free_max_attempts) {
      Swal.fire('Oops!', 'Mohon isi kolom Free Max Attempts.', 'error');
      return;
    }
    if (!form.max_assistant) {
      Swal.fire('Oops!', 'Mohon isi kolom Free Max Examination Assistant.', 'error');
      return;
    }
    if (!form.chat_max_text) {
      Swal.fire('Oops!', 'Mohon isi kolom Chat Max Text.', 'error');
      return;
    }
    if (!form.chat_max_create_session) {
      Swal.fire('Oops!', 'Mohon isi kolom Chat Max Create Session.', 'error');
      return;
    }
    if (!form.api_ai_max_token) {
      Swal.fire('Oops!', 'Mohon isi kolom API AI Max Token.', 'error');
      return;
    }

    const formData = new FormData();
    formData.append('max_assistant', form.max_assistant);
    formData.append('free_max_attempts', form.free_max_attempts);
    formData.append('chat_max_text', form.chat_max_text);
    formData.append('chat_max_create_session', form.chat_max_create_session);
    formData.append('api_ai_max_token', form.api_ai_max_token);
    formData.append('nama_aplikasi', form.nama_aplikasi);

    if (form.logo_image) formData.append('logo_image', form.logo_image);
    if (form.background_image) formData.append('background_image', form.background_image);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/setting`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });
      Swal.fire('Berhasil', 'Pengaturan berhasil disimpan', 'success');
    } catch (err) {
      Swal.fire('Oops!', err.response?.data?.message || 'Gagal menyimpan pengaturan.', 'error');
    }
  };

  return (
    <div className="container-fluid px-0">
      <div className="card custom-card-width">
        <div className="card-body">
          <div className="mb-4 flex items-center gap-2 text-slate-800">
            <Settings size={18} />
            <h4 className="text-lg font-semibold mb-0">Konfigurasi Pengaturan</h4>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="d-flex align-items-center mb-3">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>Nama Aplikasi :</label>
              <div className="flex-grow-1">
                <input
                  type="text"
                  className="form-control"
                  name="nama_aplikasi"
                  value={form.nama_aplikasi}
                  onChange={handleChange}
                  placeholder="Misal: AI Assistant App"
                />
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>Free Max Attempts :</label>
              <div className="flex-grow-1">
                <input
                  type="number"
                  className="form-control"
                  name="free_max_attempts"
                  value={form.free_max_attempts}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>Chat Maxlength Text :</label>
              <div className="flex-grow-1">
                <input
                  type="number"
                  className="form-control"
                  name="chat_max_text"
                  value={form.chat_max_text}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>Chat Max Create Session :</label>
              <div className="flex-grow-1">
                <input
                  type="number"
                  className="form-control"
                  name="chat_max_create_session"
                  value={form.chat_max_create_session}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>AI Max Token :</label>
              <div className="flex-grow-1">
                <input
                  type="number"
                  className="form-control"
                  name="api_ai_max_token"
                  value={form.api_ai_max_token}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>Free Max Examination Assistant :</label>
              <div className="flex-grow-1">
                <input
                  type="number"
                  className="form-control"
                  name="max_assistant"
                  value={form.max_assistant}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>Logo Aplikasi :</label>
              <div className="flex-grow-1">
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  name="logo_image"
                  onChange={handleChange}
                />
                {preview.logo && (
                  <div className="mt-2">
                    <img
                      src={preview.logo}
                      alt="Logo Preview"
                      style={{ maxHeight: '60px', border: '1px solid #ddd', padding: '4px' }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center mb-4">
              <label className="fw-semibold text-dark me-2" style={{ width: '260px', minWidth: '260px' }}>Background Image :</label>
              <div className="flex-grow-1">
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  name="background_image"
                  onChange={handleChange}
                />
                {preview.background && (
                  <div className="mt-2">
                    <img
                      src={preview.background}
                      alt="Background Preview"
                      style={{ maxHeight: '100px', width: '100%', objectFit: 'cover', border: '1px solid #ddd', padding: '4px' }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex">
              <div style={{ marginLeft: '268px' }}>
                <button type="submit" className="btn btn-dark px-4">Simpan</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SettingPage;